import type { DeepRequired } from '../fixtures.types'

const documentRequirement: DeepRequired<DocumentRequirement> = {
  __typename: 'DocumentRequirement',
  requirement_id: 'TEST_ID',
  created_at: null,
  created_by: null,
  details: {
    __typename: 'DocumentRequirementDetails',
    apply_to_existing: null,
    auto_satisfy: [
      {
        __typename: 'AutoSatisfy',
        document_types: [],
        count: null,
        broker_verification_required: null,
        satisfied_document_ids: [],
      },
    ],
    can_share_with_client: null,
    case_types: null,
    default_overdue: null,
    description: null,
    document_types: [],
    gi: null,
    name: null,
    organisation_id: 'TEST_ORG_ID',
    per_client: null,
    protection_types: [],
    required_by: null,
    required_from: null,
    status: null,
    exclude_renewal: null,
    exclude_no_contact_renewal: null,
    exclude_product_transfer: null,
  },
  disabled_at: null,
  modified_at: null,
}

export default documentRequirement
